<!--
 * @Description: 会议头部
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-14 16:07:33
 * @LastEditors: 山淑兰
 -->
<template>
  <div class="meethead">
    <div class="schedule-header">
      <img src="../../../../assets/m-banner.jpg">  
    </div>
    <transition name="fade">
      <Loading v-if="loading"></Loading>
    </transition>
    <!-- <div class="homeBtn" v-if="HomeUrl">
      <a :href="HomeUrl">
        <van-icon name="wap-home-o" size="30px" color="#fff"
      /></a>
    </div> -->
  </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import publicSignup from '@/lib/signUp.js'

export default {
  props: ['bannerList'],
  name: 'meethead',
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      bannerSrc: '',
      HomeUrl: '',
      publicTools: {}, //通用publicSignup
      bannerEntity: [],
    }
  },
  watch: {
    bannerList: {
      handler() {
        this.bannerEntity = this.bannerList
        console.log(this.bannerEntity)
        this.swiperInit()
      },
    },
  },
  created() {
    this.publicTools = new publicSignup()
    this.init()
    this.bannerEntity = this.bannerList
    console.log(this.bannerEntity)
  },
  mounted(){
    this.swiperInit()
  },
  methods: {
    swiperInit() {
      this.$nextTick(function() {
        var bannerSwiper = new Swiper('.schedule-header-banner', {
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          loop: true,
          pagination: {
            el: '.pagination',
          }
        })
      })
    },
    async init() {
      try {
        this.loading = true
        let { m, ch } = this.$route.query
        let opt = {
          m,
          ch,
        }
        const headRes = await this.publicTools.init(opt, this)
        document.title = headRes.MeetingTitle
        if (this.$route.query.red != 'im' && this.$route.query.red != 'all') {
          //获取bnner图路径
          this.bannerSrc = headRes.MobileBannerImage
          this.HomeUrl = headRes.HomeUrl
        }
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.meethead{
  width: 100%;
}
.schedule-header {
  width: 100%;
  height: 392px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.homeBtn {
  z-index: 999;
  position: fixed;
  right: 8px;
  bottom: 160px;
  i {
    width: 80px;
    height: 80px;
    background: #1899ff;
    text-align: center;
    border-radius: 2rem;
    &::before {
      margin-top: 8px;
    }
  }
}
.schedule-header-banner{
  overflow: hidden;
  width: 100%;
  height: 392px;
  .swiper-slide{
    position: relative;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
}
</style>
<style type="text/css">
.pagination {
  position:absolute;
  z-index: 20;
  bottom: 10px;
  text-align:center;
  right: 0;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet {
  display:inline-block;
  width: 14px;
  height: 14px;
  border-radius: 14px;
  background:#fff;
  margin: 0 10px;
  opacity: 1;
  cursor:pointer;
}
.swiper-pagination-bullet-active {
  background: #00439a;
}
</style>
